<template>
  <div class="container-list  flex-column" style="height: 100%;">
    <div class="flex" style="flex: 1;">
      <tab2 :cpNum="cpNum" ref="water"></tab2>
      <tab5 :cpNum="cpNum" :nowDevice="nowDeviceMessage" ref="waterbeng"></tab5>
    </div>
  </div>
</template>
<script>
import tab5 from '../views/facility/tab5.vue';
import tab2 from '../views/facility/tab2.vue';

import config from '@/utils/config.js';

import { mapState } from 'vuex';
if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsDevicetest;
} else if (process.env.NODE_ENV == 'production') {
  //线上
  var wsUrl = config.wsDeviceUrl;
}
export default {
  name: 'facility',

  components: {
    tab2,
    tab5,
  },
  props: ['homeComp'],
  data() {
    return {
      // nowIndex: this.$route.query.index || 0,
      cpNum: this.homeComp || '',
      nowid: '',

      company: '',
      nowMessage: '',
      nowDeviceMessage: '',
      nowWarning: false,
    };
  },

  computed: {
    ...mapState(['isMute', 'isWaring', 'bjList', 'isLoop', 'showFire', 'alarmDtItem']),
  },
  created() {
    if (this.$route.query.index == 0) {
      this.nowIndex = 8;
    }
    this.getWarning(this.isWaring);
  },
  mounted() {
    var me = this;
    var ws;
    var lockReconnect = false; //避免重复连接

    createWebSocket(); // 创建websocket

    function createWebSocket() {
      try {
        me.ws = new WebSocket(wsUrl);
        websocketInit();
      } catch (e) {
        log('catch');
        websocketReconnect(wsUrl);
      }
    }

    function websocketInit() {
      // 建立 web socket 连接成功触发事件
      me.ws.onopen = function(evt) {
        onOpen(evt);
      };
      // 断开 web socket 连接成功触发事件
      me.ws.onclose = function(evt) {
        websocketReconnect(wsUrl);
        onClose(evt);
      };
      // 接收服务端数据时触发事件
      me.ws.onmessage = function(evt) {
        onMessage(evt);
      };
      // 通信发生错误时触发
      me.ws.onerror = function(evt) {
        websocketReconnect(wsUrl);
        onError(evt);
      };
    }

    function onOpen(evt) {
      log('建立设备链接');
      //心跳检测重置
      if (!me.heartCheck.isStart) {
        me.heartCheck.start();
      }
    }

    function onClose(evt) {}

    function onMessage(evt) {
      // console.log(evt)
      if (evt.data === '"shoudao"') {
      } else {
        //！！这里接受消息 写东西
        var data = JSON.parse(evt.data);
        setTimeout(() => {
          me.nowDeviceMessage = data;
        }, 1000);
      }
      //拿到任何消息都说明当前连接是正常的
      me.heartCheck.start();
    }

    function websocketReconnect(url) {
      if (lockReconnect) {
        // 是否已经执行重连
        return;
      }
      lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt);
      var tt = setTimeout(function() {
        createWebSocket(url);
        lockReconnect = false;
      }, 5000);
    }

    //心跳检测
    me.heartCheck = {
      timeout: 5000,
      timeoutObj: null,
      serverTimeoutObj: null,
      isStart: false,
      start: function() {
        var self = this;
        this.isStart = true;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function() {
          //发送测试信息，后端收到后，返回一个消息，
          me.ws.send('fasong');
          self.serverTimeoutObj = setTimeout(function() {
            me.ws.close();
          }, self.timeout);
        }, this.timeout);
      },
    };

    function onError(evt) {
      log('通信错误：' + evt.data);
    }
  },
  watch: {
    bjList(it) {
      this.nowMessage = it[0];
    },
    homeComp(v) {
      if (v) {
        this.cpNum = v;
      } else {
        this.cpNum = '';
      }
    },
    isWaring(val) {
      this.nowWarning = val;
      this.getWarning(val);
      //  for(var i in this.$refs){
      //   if(this.$refs[i]){
      //     this.$refs[i].changeFireStatus(val,this.nowMessage)
      //   }
      //  }
      //  console.log(this.$refs['fire'])
    },
  },
  beforeDestroy() {
    this.ws.close();
    this.ws.onclose = function() {
      console.log('设备关闭');
    };
  },
  methods: {
    // 接受报警
    getWarning(val) {
      // alert('warning')
      if (val || this.isWaring) {
        // 报警中 下发给组件此次报警
        //  查找最近的一条 超限报警
        this.nowMessage = this.$store.state.bjList[0];
      } else {
        this.nowMessage = '';
      }

      for (var i in this.$refs) {
        if (this.$refs[i]) {
          // console.log(232323)

          // console.log(this.$refs[i].changeFireStatus)
          if (this.$refs[i].changeFireStatus) this.$refs[i].changeFireStatus(val, this.nowMessage);
        }
      }
    },
  },
};
</script>
<style lang="scss"></style>
